(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('qsched-type', {
            parent: 'entity',
            url: '/qsched-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.qsched_type.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/qsched-type/qsched-types.html',
                    controller: 'Qsched_typeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('qsched_type');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('qsched-type-detail', {
            parent: 'entity',
            url: '/qsched-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.qsched_type.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/qsched-type/qsched-type-detail.html',
                    controller: 'Qsched_typeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('qsched_type');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Qsched_type', function($stateParams, Qsched_type) {
                    return Qsched_type.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'qsched-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('qsched-type-detail.edit', {
            parent: 'qsched-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-type/qsched-type-dialog.html',
                    controller: 'Qsched_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Qsched_type', function(Qsched_type) {
                            return Qsched_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('qsched-type.new', {
            parent: 'qsched-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-type/qsched-type-dialog.html',
                    controller: 'Qsched_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('qsched-type', null, { reload: 'qsched-type' });
                }, function() {
                    $state.go('qsched-type');
                });
            }]
        })
        .state('qsched-type.edit', {
            parent: 'qsched-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-type/qsched-type-dialog.html',
                    controller: 'Qsched_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Qsched_type', function(Qsched_type) {
                            return Qsched_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('qsched-type', null, { reload: 'qsched-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('qsched-type.delete', {
            parent: 'qsched-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-type/qsched-type-delete-dialog.html',
                    controller: 'Qsched_typeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Qsched_type', function(Qsched_type) {
                            return Qsched_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('qsched-type', null, { reload: 'qsched-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
